import React from 'react';

const WholesalePartsHubHeader: React.FC = ({ children }) => (
  <React.Fragment>
    <h1>{children}</h1>
    {/* language=CSS */}
    <style jsx>{`
      h1 {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 24px;
        font-weight: 500;
        text-transform: uppercase;
        margin: 0 0 1rem;
        text-align: center;
      }
    `}</style>
  </React.Fragment>
);

export default WholesalePartsHubHeader;
